import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [statusMsg, setStatusMsg] = useState('');
  const [statusType, setStatusType] = useState<'success' | 'error' | ''>('');

  const formUrl = 'https://readdy.ai/api/form/d9onslqqs38sj6jc7c80';

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    if (!formData.get('email')?.toString().trim()) {
      return;
    }

    const honeypot = formData.get('website_alt')?.toString().trim();
    if (honeypot) {
      setStatusType('success');
      setStatusMsg('订阅成功！感谢您的关注');
      setEmail('');
      return;
    }

    try {
      const searchParams = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'website_alt') {
          searchParams.append(key, value.toString());
        }
      });

      const res = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: searchParams.toString(),
      });
      const text = await res.text();
      let parsed;
      try { parsed = JSON.parse(text); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setStatusType('success');
        setStatusMsg('订阅成功！感谢您的关注');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text;
        if (serverMsg.includes('spam')) {
          setStatusType('error');
          setStatusMsg('提交失败，请稍后重试');
        } else {
          setStatusType('error');
          setStatusMsg(serverMsg || '订阅失败，请稍后重试');
        }
      }
    } catch {
      setStatusType('error');
      setStatusMsg('网络错误，请检查连接后重试');
    }
  };

  return (
    <section className="w-full px-4 md:px-6 py-16 bg-primary-500">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-background-50">
          订阅更新提醒
        </h2>
        <p className="mt-2 text-background-50/80 text-sm">
          第一时间获取最新漫画更新通知，精彩不错过
        </p>

        <form
          className="mt-6 flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          data-readdy-form=""
          onSubmit={handleSubmit}
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入您的邮箱"
            className="flex-1 px-4 py-3 rounded-lg bg-background-50 text-foreground-900 text-sm placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-background-50/50"
            required
          />
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="absolute opacity-0 pointer-events-none"
          />
          <button
            type="submit"
            className="px-6 py-3 rounded-lg bg-foreground-950 text-background-50 font-medium text-sm hover:bg-foreground-900 transition-colors whitespace-nowrap cursor-pointer"
          >
            立即订阅
          </button>
        </form>

        {statusMsg && (
          <p className={`mt-3 text-sm ${statusType === 'success' ? 'text-background-50' : 'text-background-50/90'}`}>
            {statusMsg}
          </p>
        )}
      </div>
    </section>
  );
}